export const csCertSpecializations = [
  {
    title: 'AI Engineering Specialization',
    issuer: 'Scrimba',
    issued: 'Sep 2025',
    id: 'W3YS4GYE5MOO',
    link: 'https://www.coursera.org/account/accomplishments/specialization/W3YS4GYE5MOO',
    courses: [
      {
        title: 'Build AI Apps with LangChain.js',
        issued: 'Sep 2025',
        id: 'GQ54U2XT9GIO',
        link: 'https://www.coursera.org/account/accomplishments/certificate/GQ54U2XT9GIO',
      },
      {
        title: "Learn OpenAI's Assistant API",
        issued: 'Sep 2025',
        id: '8KFSSXD0PPRA',
        link: 'https://www.coursera.org/account/accomplishments/certificate/8KFSSXD0PPRA',
      },
      {
        title: 'Intro to Dall-E and GPT Vision',
        issued: 'Sep 2025',
        id: 'U2823L4N0IWF',
        link: 'https://www.coursera.org/account/accomplishments/certificate/U2823L4N0IWF',
      },
      {
        title: 'Learn AI Agents',
        issued: 'Aug 2025',
        id: 'S6N0YJ8DZBP1',
        link: 'https://www.coursera.org/account/accomplishments/certificate/S6N0YJ8DZBP1',
      },
      {
        title:
          'Retrieval-Augmented Generation (RAG) with Embeddings & Vector Databases',
        issued: 'Aug 2025',
        id: 'W3AVQQWSZQJ1',
        link: 'https://www.coursera.org/account/accomplishments/certificate/W3AVQQWSZQJ1',
      },
      {
        title: 'Open-source AI Models',
        issued: 'Aug 2025',
        id: 'KGWF53AB39A9',
        link: 'https://www.coursera.org/account/accomplishments/certificate/KGWF53AB39A9',
      },
      {
        title: 'Deploy AI Apps with Cloudflare',
        issued: 'Aug 2025',
        id: 'XLVPHCDMGR1H',
        link: 'https://www.coursera.org/account/accomplishments/certificate/XLVPHCDMGR1H',
      },
      {
        title: 'Intro to AI Engineering',
        issued: 'Aug 2025',
        id: 'SR85Y4R2L05Z',
        link: 'https://www.coursera.org/account/accomplishments/certificate/SR85Y4R2L05Z',
      },
    ],
  },
  {
    title: 'Meta Front-End Developer Certification',
    issuer: 'Meta',
    issued: 'Apr 2025',
    id: 'U82W9O43ICKK',
    link: 'https://www.coursera.org/account/accomplishments/professional-cert/U82W9O43ICKK',
    courses: [
      {
        title: 'Coding Interview Preparation',
        issued: 'Apr 2025',
        id: 'Z3TLYL1DXNBJ',
        link: 'https://www.coursera.org/account/accomplishments/certificate/Z3TLYL1DXNBJ',
      },
      {
        title: 'Front-End Developer Capstone',
        issued: 'Mar 2025',
        id: 'AAG6FR7ZOS30',
        link: 'https://www.coursera.org/account/accomplishments/certificate/AAG6FR7ZOS30',
      },
      {
        title: 'Advanced React',
        issued: 'Jan 2025',
        id: '4E399ZJOS4W7',
        link: 'https://www.coursera.org/account/accomplishments/certificate/4E399ZJOS4W7',
      },
      {
        title: 'Principles of UX/UI Design',
        issued: 'Jan 2025',
        id: 'YEBLSMEUM0TN',
        link: 'https://www.coursera.org/account/accomplishments/certificate/YEBLSMEUM0TN',
      },
      {
        title: 'React Basics',
        issued: 'Jan 2025',
        id: 'TKNSGOS95JIA',
        link: 'https://www.coursera.org/account/accomplishments/certificate/TKNSGOS95JIA',
      },
      {
        title: 'HTML and CSS in depth',
        issued: 'Dec 2024',
        id: 'MMTVENVML2NO',
        link: 'https://www.coursera.org/account/accomplishments/certificate/MMTVENVML2NO',
      },
      {
        title: 'Programming with JavaScript',
        issued: 'Dec 2024',
        id: 'M9GBQMWJTW9X',
        link: 'https://www.coursera.org/account/accomplishments/certificate/M9GBQMWJTW9X',
      },
      {
        title: 'Version Control',
        issued: 'Dec 2024',
        id: 'K31UYUXWEY7E',
        link: 'https://www.coursera.org/account/accomplishments/certificate/K31UYUXWEY7E',
      },
      {
        title: 'Introduction to Front-End Development',
        issued: 'Nov 2024',
        id: 'GP5JSKAXQCXJ',
        link: 'https://www.coursera.org/account/accomplishments/certificate/GP5JSKAXQCXJ',
      },
    ],
  },
  {
    title: 'The Complete JavaScript Course - Beginner to Professional',
    issuer: 'Udemy',
    issued: 'Jan 2021',
    id: 'UC-8c1e0815-aa37-4180-ac2d-a5553ba83167',
    link: 'https://www.udemy.com/certificate/UC-8c1e0815-aa37-4180-ac2d-a5553ba83167',
    courses: [
      {
        title: 'JavaScript Next Steps',
      },
      {
        title: 'Helpful JavaScript Code Snippets',
      },
      {
        title: 'Questions Answer Code Snipper Useful JavaScript Code',
      },
      {
        title: 'Reaction Game Setup',
      },
      {
        title: 'JavaScript InAction',
      },
      {
        title: "What's new ECMAScript 6",
      },
      {
        title: 'JSON and AJAX JavaScript',
      },
      {
        title: 'HTML5 JavaScript',
      },
      {
        title: 'Intermediate JavaScript',
      },
      {
        title: 'Built-in JavaScript',
      },
      {
        title: 'JavaScript Dynamic Web with the DOM',
      },
      {
        title: 'Interactive Content JavaScript DOM and More',
      },
      {
        title: 'JavaScript Functions',
      },
      {
        title: 'JavaScript Loops',
      },
      {
        title: 'JavaScript Logic Statements',
      },
      {
        title: 'Document Object Model Basics',
      },
      {
        title: 'JavaScript Multiple Values',
      },
      {
        title: 'JavaScript Essentials',
      },
      {
        title: 'Getting Started with JavaScript',
      },
    ],
  },
];

export const uxCertSpecializations = [
  {
    title: 'Google UX Design Specialization',
    issuer: 'Google',
    issued: 'Sep 2024',
    id: '44N444UAAEV2',
    link: 'https://www.coursera.org/account/accomplishments/professional-cert/44N444UAAEV2',
    courses: [
      {
        title: 'Design a User Experience for Social Good & Prepare for Jobs',
        issued: 'Sep 2024',
        id: 'Y4NKB4N0UU21',
        link: 'https://www.coursera.org/account/accomplishments/certificate/Y4NKB4N0UU21',
      },
      {
        title: 'Build Dynamic User Interfaces (UI) for Websites',
        issued: 'Feb 2024',
        id: 'MKNTUR44D2AG',
        link: 'https://www.coursera.org/account/accomplishments/certificate/MKNTUR44D2AG',
      },
      {
        title: 'Create High-Fidelity Designs and Prototypes in Figma',
        issued: 'Nov 2023',
        id: 'SW9N6BJLGD2Y',
        link: 'https://www.coursera.org/account/accomplishments/certificate/SW9N6BJLGD2Y',
      },
      {
        title: 'Conduct UX Research and Test Early Concepts',
        issued: 'Mar 2023',
        id: '9WQYV4U23EPB',
        link: 'https://www.coursera.org/account/accomplishments/certificate/9WQYV4U23EPB',
      },
      {
        title: 'Build Wireframes and Low-Fidelity Prototypes',
        issued: 'Jan 2023',
        id: 'GTP37AXJ5T2Y',
        link: 'https://www.coursera.org/account/accomplishments/certificate/GTP37AXJ5T2Y',
      },
      {
        title: 'Start the UX Design Process: Empathize, Define, and Ideate',
        issued: 'Dec 2022',
        id: '4V5GSXJRXXWE',
        link: 'https://www.coursera.org/account/accomplishments/certificate/4V5GSXJRXXWE',
      },
      {
        title: 'Foundations of User Experience (UX) Design',
        issued: 'Nov 2022',
        id: 'DMRGE93KYZ8U',
        link: 'https://www.coursera.org/account/accomplishments/certificate/DMRGE93KYZ8U',
      },
    ],
  },
];

// const csCert = [
//   {
//     title: 'Angular JS Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Jan 2021',
//     id: '1610821777850',
//     link: 'https://git.io/JtYvw',
//   },
//   {
//     title: 'HTML Advanced Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Jan 2021',
//     id: '1610823810015',
//     link: 'https://git.io/JtYvI',
//   },
//   {
//     title: 'HTML Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Jan 2021',
//     id: '1610822982546',
//     link: 'https://git.io/JtYej',
//   },
//   {
//     title: 'React Development Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Jan 2021',
//     id: '1610071931595',
//     link: 'https://git.io/JLp2G',
//   },
//   {
//     title: 'JavaScript Advanced Certification Course ',
//     issuer: 'Programming Hub',
//     issued: 'Aug 2020',
//     id: '1597003305646',
//     link: 'https://git.io/JJMC2',
//   },
//   {
//     title: 'JavaScript Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Aug 2020',
//     id: '1596676590743',
//     link: 'https://git.io/JJMcp',
//   },
//   {
//     title: 'Python Advanced Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Aug 2020',
//     id: '1597003975986',
//     link: 'https://git.io/JJMCE',
//   },
//   {
//     title: 'Python Certification Course',
//     issuer: 'Programming Hub',
//     issued: 'Aug 2020',
//     id: '1597003864515',
//     link: 'https://git.io/JJMcc',
//   },
// ];
